module.exports = __webpack_public_path__ + "media/images/common/ico-lottery-w-991ac7268fae00b1e0a039a2cea716dd.svg";